import { render, staticRenderFns } from "./block-errors.vue?vue&type=template&id=5a0ef468&scoped=true&"
import script from "./block-errors.vue?vue&type=script&lang=js&"
export * from "./block-errors.vue?vue&type=script&lang=js&"
import style0 from "./block-errors.vue?vue&type=style&index=0&id=5a0ef468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ef468",
  null
  
)

export default component.exports